// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__qSRm8","label":"Alert_label__IWMff","text":"Alert_text__T6zXs","button":"Alert_button__oVopc"};